/**
 * Internal dependencies
 */
import { getNumberOfAlternatives } from './get-number-of-alternatives';
import { isAlternativeDistributionAllowed } from './is-alternative-distribution-allowed';
import type { Session } from '../../types';

export function getCollapsedAlternative( session: Session ): number {
	return isAlternativeDistributionAllowed( session )
		? session.alternative
		: session.alternative % getNumberOfAlternatives( session );
}
